import React from 'react';
import { Handshake } from 'lucide-react';
import { WaitlistForm } from './WaitlistForm';

export const PartnerCta = () => (
  <section id="partners" className="border-y border-border bg-muted/50" data-testid="partner-section">
    <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 py-20 md:grid-cols-2 md:px-12">
      <div>
        <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Handshake className="h-6 w-6" />
        </div>
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary">Partner programme</p>
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
          Wedding planner, venue or brand?
        </h2>
        <p className="mt-4 max-w-md text-base leading-relaxed text-muted-foreground">
          Work with couples, parties or corporate clients? Join our partner programme before
          launch and earn on every gift experience you help create — from birthdays to weddings
          to employee milestones.
        </p>
      </div>
      <div className="md:justify-self-end">
        <p className="mb-3 text-sm font-semibold text-foreground">Register your interest — we'll be in touch first.</p>
        <WaitlistForm idPrefix="partner" source="partner" ctaLabel="Become a partner" onJoined={() => {}} />
      </div>
    </div>
  </section>
);
